// removed by extract-text-webpack-plugin
module.exports = {"header":"general__header___2HqWF height-100 transitionDuration-l width-100","overlay":"general__overlay___PgmhY bg-black opacity-90 pinAll position-absolute"};


//////////////////
// WEBPACK FOOTER
// ./packages/marvel-ui-card/CardBody/style/general.css
// module id = 128
// module chunks = 0 1